import { jsx as r, Fragment as j } from "react/jsx-runtime";
import { isBoolean as S } from "lodash/fp";
import { CUSTOM_CELLS_WITH_CUSTOM_SKELETON as $ } from "./index.es531.js";
import { getCustomCellingComponents as A } from "./index.es2349.js";
import { suppressKeyboardEvent as B } from "./index.es5532.js";
import { SkeletonCell as s } from "./index.es5533.js";
import { BooleanCell as F } from "./index.es5534.js";
import { NumericCell as K } from "./index.es5535.js";
import { BaseHeader as V } from "./index.es5536.js";
const z = ({
  headerComponent: m,
  cellType: o,
  menuItems: C,
  propsToDrill: a,
  field: d,
  numericConfigurations: H,
  loadingRows: g,
  loading: L
}) => {
  let I;
  m && (I = Object.entries(m).filter(([e]) => e !== "testId").map(([, e]) => e)[0]);
  const { CellComponent: v, HeaderComponent: b } = A({
    headerComponent: m,
    cellType: o
  });
  return {
    suppressKeyboardEvent: v ? B : void 0,
    headerComponentParams: I,
    headerComponent: b ? (e) => /* @__PURE__ */ r(b, { ...e, ...a, menuItems: C }) : (e) => {
      const i = e.column.colDef.testId || e.column.colId;
      return /* @__PURE__ */ r(
        V,
        {
          ...e,
          ...a,
          menuItems: C,
          testId: a.testId ? `${a.testId}-header-${i}` : "data-grid-header"
        }
      );
    },
    cellRenderer: (e) => {
      var w, E;
      const i = () => {
        var c;
        const t = (c = e.colDef) == null ? void 0 : c.valueFormatter, n = e.data[d];
        if (t) {
          const u = { ...e, value: n };
          return t(u);
        }
        return n;
      }, O = () => {
        var n;
        const t = e.colDef.testId || ((n = e.column) == null ? void 0 : n.getColId());
        return a.testId ? `${a.testId}-row-${e.node.rowIndex}-cell-${t}` : "data-grid-cell";
      }, x = () => {
        var n;
        const t = (n = e.colDef) == null ? void 0 : n.loading;
        return L ? !0 : g ? g.includes(e.node.rowIndex) : typeof t == "boolean" ? t : t == null ? void 0 : t(e.data, e.node.rowIndex);
      }, l = i(), h = ((w = e.colDef) == null ? void 0 : w.cellDataType) === "number" || typeof e.value == "number" && !isNaN(Number(l)) && !S(e.value), N = o === "color-indicator" ? "center" : h ? "right" : "left", _ = (t, n = {}) => {
        const c = typeof e.data[d] == "object" ? { ...e.data[d] } : { value: e.data[d] }, u = {
          colDef: e.colDef,
          gridApi: e.api,
          ...c,
          rowData: e.data,
          ...a,
          formatValue: l,
          value: e.data[d],
          ...n
        };
        return x() && $.includes(o) ? /* @__PURE__ */ r(s, { align: N, children: /* @__PURE__ */ r(t, { ...u }) }) : /* @__PURE__ */ r(t, { ...u });
      };
      let f = v;
      return S(e.value) ? /* @__PURE__ */ r(s, { children: /* @__PURE__ */ r(F, { id: ((E = e == null ? void 0 : e.node) == null ? void 0 : E.id) || "" }) }) : (h && (f = K, a = { ...a, ...H }), x() && !$.includes(o) ? /* @__PURE__ */ r(s, { align: N }) : f ? _(f) : (e.eGridCell.setAttribute("data-testid", O()), /* @__PURE__ */ r(j, { children: l })));
    }
  };
};
export {
  z as getCustomCelling
};
//# sourceMappingURL=index.es2344.js.map
